import React, { useState, useEffect } from "react";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import { defaultAction } from "@actions/defaultAction";
import { SHOW_SIGN_IN_POPUP_MODAL } from "@constants/actionTypes";
import styled from "@emotion/styled";
import AgreementTerms from "./AgreementTerms";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const CartCheckoutButtonMainContainer = styled.div`
  padding-top: 0px;
  padding-bottom: 0px;
  box-shadow: 0;
  background-color: inherit;
  margin-top: 0;
  border-radius: 0;

  @media (max-width: 1100px) {
    box-shadow: none;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
  }
`;

const ButtonContainer = styled.div`
  padding-right: 0px;
  padding-left: 0px;

  @media (max-width: 1430px) {
    padding-right: 0px;
    padding-left: 0px;
  }
`;

const CartCheckoutButton = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const signedIn = useSelector(state => state.initAppReducer.signedIn);
  const cartErrorMsg = useSelector(state => state.cartBuy.cartErrorMsg);

  let theCustomerSignedIn = !!signedIn;
  const [disableButton, changeDisableButton] = useState(false);
  const [checkboxChecked, changeCheckedBoxChecked] = useState(true);

  useEffect(() => {
    if (cartErrorMsg) {
      changeDisableButton(true);
    } else {
      if (checkboxChecked) changeDisableButton(false);
    }
  }, [cartErrorMsg]);

  const handleCheckoutButtonClick = disabled => {
    if (disableButton || disabled) return;

    if (!theCustomerSignedIn) {
      dispatch(defaultAction(SHOW_SIGN_IN_POPUP_MODAL, "cartPage"));
    } else {
      if (cartErrorMsg) {
        return;
      }
      history.push("/checkout/");
    }
  };

  const handleCheckbox = e => {
    if (e.target.checked) {
      changeCheckedBoxChecked(true);
      if (!cartErrorMsg) {
        changeDisableButton(false);
      }
    } else {
      changeCheckedBoxChecked(false);
      changeDisableButton(true);
    }
  };

  return (
    <CartCheckoutButtonMainContainer>
      <AgreementTerms
        checkboxChecked={checkboxChecked}
        onChange={handleCheckbox}
      />
      <ButtonContainer>
        <DefaultOrangeButton
          handleClick={handleCheckoutButtonClick}
          disabled={disableButton || !checkboxChecked}
          classes={"cart-page-checkout-button"}
        >
          {theCustomerSignedIn ? "Checkout" : "Login & Checkout"}
        </DefaultOrangeButton>
      </ButtonContainer>
    </CartCheckoutButtonMainContainer>
  );
};

export default CartCheckoutButton;
